/*@flow*/
import styled from '@emotion/styled';

export default (styled.div(
  `
  animation: loader-progress 1000ms linear 1;
  opacity: 0;
  filter: alpha(opacity=(0 * 100)); // IE10
  transition: opacity 1000ms;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #1181FB;
  z-index: 2;

  @include keyframes(loader-progress) {
    0% {
      width: 0;
    }
    100% {
      width: 100%;
    }
  }
`,
  (props: { isVisible?: boolean }) =>
    props.isVisible
      ? `
  animation: loader-progress 2000ms linear infinite;
  opacity: 1;
  filter: alpha(opacity=(1 * 100)); // IE10
  `
      : ''
): any);
